import React, { useState, useEffect, useMemo } from "react";
import i18n from "i18next";
import { api } from "./Requests/Api";
import { useAppContext } from "./State/Global/AppContext";
import { Spin } from "antd";
import Agent from "./Views/Agent/Agent";
import Login from "Views/Login/Login";
import "./Lang/i18n";
import moment from "moment";
import "moment/locale/es";

import { ConfigProvider } from "antd";
import enUS from "antd/lib/locale/en_US";
import esES from "antd/lib/locale/es_ES";
import * as queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import "@ionic/react/css/core.css";
import { IonApp, setupIonicReact } from "@ionic/react";
import { StatusBar, Style } from "@capacitor/status-bar";
import { isNativeMobile } from "frontend-lib/Utils/Mobile";
import { Keyboard } from "@capacitor/keyboard";
import { SplashScreen } from "@capacitor/splash-screen";

setupIonicReact();

// Ionic ios has a bug where the whole app jumps down when an input is selected
// This line prevents it
if (isNativeMobile()) Keyboard.setScroll({ isDisabled: true });

function App() {
    const { actions, appState } = useAppContext();
    const [isLoading, setIsLoading] = useState(true);
    const [antdLang, setAntdLang] = useState(enUS);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (isNativeMobile()) {
            StatusBar.setStyle({ style: Style.Light });
        }
    }, []);

    useEffect(() => {
        if (!isLoading) SplashScreen.hide();
    }, [isLoading]);

    const isAuthenticated = useMemo(() => {
        return appState.isAuthenticated;
    }, [appState.isAuthenticated]);

    useEffect(() => {
        const searchQueryString = queryString.parse(location.search);
        if (searchQueryString.accessToken) {
            localStorage.setItem("token", searchQueryString.accessToken);
            navigate(window.location.pathname);
        }

        api.auth()
            .isAuthenticated()
            .then((authRes) => {
                api.auth()
                    .getWorkspace(authRes.data.workspace.id)
                    .then((workspaceRes) => {
                        let currentUserId = authRes.data.id;
                        let workspaceConfigs = workspaceRes.data.jsonConfigs;

                        const workspaceName = workspaceRes.data.name;
                        actions.setWorkspaceName(workspaceName);

                        if (
                            workspaceConfigs?.backend?.conversationOrderingTypeByUserId &&
                            currentUserId.toString() in
                                workspaceConfigs.backend.conversationOrderingTypeByUserId &&
                            workspaceConfigs.backend.conversationOrderingTypeByUserId[currentUserId]
                        ) {
                            workspaceConfigs.backend.conversationOrderingType =
                                workspaceConfigs.backend.conversationOrderingTypeByUserId[
                                    currentUserId
                                ];
                        }
                        actions.setWorkspaceConfig(workspaceConfigs);
                        actions.setAuth(true, authRes.data);
                        if (workspaceRes.data.jsonConfigs.language === "SPANISH") {
                            i18n.changeLanguage("es");
                            moment.locale("es");
                            setAntdLang(esES);
                            setIsLoading(false);
                        }
                        if (workspaceRes.data.jsonConfigs.language === "ENGLISH") {
                            i18n.changeLanguage("en");
                            setAntdLang(enUS);
                            setIsLoading(false);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setIsLoading(false);
                    });
            })
            .catch(() => {
                actions.setAuth(false);
                setIsLoading(false);
            });
        // eslint-disable-next-line
    }, [isAuthenticated]);

    function wrapInConfigProvider(Component) {
        const ionAppWrapper = (children) => {
            if (isNativeMobile()) {
                return (
                    <IonApp
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {children}
                    </IonApp>
                );
            }
            return <>{children}</>;
        };

        return ionAppWrapper(
            <ConfigProvider locale={antdLang}>
                <Component></Component>
            </ConfigProvider>
        );
    }

    if (isAuthenticated) {
        return wrapInConfigProvider(Agent);
    }

    return wrapInConfigProvider(Login);
}

export default App;
